// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2VjRJ","select":"Header_select__20Tab","clinic":"Header_clinic__3OLdN"};